module.exports = __webpack_public_path__ + "static/media/xmg_1.778cdeca.png";